import { T } from "../../app/tokens.js";

export const OFFICE_LEASE_LINK_TYPE_STYLE = Object.freeze({
  fontSize: T.fsBase,
  fontWeight: T.fwBold,
  color: T.blue,
});